import { render, staticRenderFns } from "./FormInstructions.vue?vue&type=template&id=49b5a629&scoped=true&"
import script from "./FormInstructions.vue?vue&type=script&lang=js&"
export * from "./FormInstructions.vue?vue&type=script&lang=js&"
import style0 from "./FormInstructions.vue?vue&type=style&index=0&id=49b5a629&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b5a629",
  null
  
)

export default component.exports